// src/routes.tsx
import { createBrowserRouter } from "react-router-dom";
import App from "./App"; // layout-komponent (t.ex. med header/footer)
import Home from "./Pages/Home/Home";
import Admin from "./Pages/Admin/Admin";
import Loading from "./components/Loading/Loading";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <App />, // gemensam layout
    errorElement: <Loading />,
    children: [
      { index: true, element: <Home /> },
      { path: "admin", element: <Admin /> },
    ],
  },
]);
